import { useMutation, useQueryClient } from "@tanstack/react-query"
import { apiClient } from "@/shared/lib/apiClient"
import { unwrap } from "@/shared/utils/unwrap"
import type { LoginValues, RegisterValues } from "../auth.schemas"
import { meQueryOptions } from "./auth.queries"

export function useLoginMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (values: LoginValues) =>
      unwrap(apiClient.POST("/api/auth/login", { body: values })),
    onSuccess: (user) => {
      queryClient.setQueryData(meQueryOptions.queryKey, user)
    },
  })
}

export function useRegisterMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (values: RegisterValues) =>
      unwrap(
        // confirmPassword is form-only.
        apiClient.POST("/api/auth/register", {
          body: { username: values.username, password: values.password },
        }),
      ),
    onSuccess: (user) => {
      queryClient.setQueryData(meQueryOptions.queryKey, user)
    },
  })
}

export function useLogoutMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => unwrap(apiClient.POST("/api/auth/logout")),
    onSuccess: () => {
      queryClient.clear()
    },
  })
}
